<template>
  <div>
    <b-modal
      id="modal-center"
      v-model="modalHistorico"
      hide-header
      hide-footer
      centered
      size="lg"
      title="BootstrapVue"
    >
      <div class="d-flex justify-content-between align-items-center mx-2 mb-4">
        <h4 class="mb-0">Histórico</h4>
        <i
          @click="modalHistorico = false"
          class="fa-solid fa-xmark"
          style="cursor: pointer"
        ></i>
      </div>
      <b-table
        hover
        :items="itemAberto.historico_numeros"
        :fields="fieldsTableHistorico"
        empty-text="Nenhum registro encontrado"
      >
        <template #cell(numero_linha)="row">
          {{ formatarTelefone(row.value) }}
        </template>

        <template #cell(primeira_ativacao)="row">
          {{ formatarData(row.value) }}
        </template>

        <template #cell(ultima_ativacao)="row">
          {{ formatarData(row.value) }}
        </template>

        <template #cell(esquenta_chip_ativo)="row">
          <b-badge v-if="row.value == 'S'" variant="success">Ativo</b-badge>
          <b-badge v-else variant="danger">Inativo</b-badge>
        </template>

        <template #cell(aparelho)="row">
          {{ row.value || "Não informado" }}
        </template>
      </b-table>
    </b-modal>
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <h5 class="card-label">Histórico de números</h5>
        </div>

        <hr />
        <div class="d-flex align-items-start mt-5">
          <div class="d-flex flex-column">
            <MultiSelect
              v-model="contasSelecioandas"
              :options="contas"
              style="width: 300px"
              class="mr-3"
              :class="{
                'p-invalid': !contasSelecioandas.length && contasInvalidas
              }"
              optionValue="id"
              optionLabel="label"
              placeholder="Selecione a conta"
              :filter="true"
            >
              <template #option="slotProps">
                <div class="country-item">
                  <div>
                    {{ slotProps.option.id }} -
                    {{ slotProps.option.login }}
                    {{
                      slotProps.option.nome ? `(${slotProps.option.nome})` : ""
                    }}
                  </div>
                </div>
              </template>
            </MultiSelect>
            <small
              class="p-invalid"
              v-if="!contasSelecioandas.length && contasInvalidas"
              >Selecione uma conta, caso não tenha nenhum telefone</small
            >
          </div>
        </div>
        <b-table
          striped
          hover
          :items="itensFiltrados"
          :fields="fields"
          :busy="isLoading"
          :currentPage="currentPage"
          :perPage="perPage"
          responsive="sm"
          empty-text="Nenhum registro encontrado"
          @sort-changed="sortChanged"
          style="min-height: 450px"
        >
          <template #cell(conta_id)="row">
            {{ contas.find((c) => c.id === row.value).login }} ({{ row.value }})
          </template>

          <template #cell(_telefone)="row">
            {{ formatarTelefone(row.value) || "Não informado" }}
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner small type="grow"></b-spinner>
              <span class="ml-2">Carregando...</span>
            </div>
          </template>

          <template #empty>
            <div class="text-center my-2">
              <b-icon icon="exclamation-circle" variant="danger" size="2rem" />
              <p>Nenhum registro encontrado</p>
            </div>
          </template>

          <template #cell(actions)="row">
            <b-button @click="abrirModalHistorico(row.item)"
              ><i class="fa-solid fa-mobile-screen p-0"></i
            ></b-button>
          </template>
        </b-table>

        <div v-if="!items.length">
          <b-alert show variant="info"> Nenhum registro encontrado </b-alert>
        </div>

        <div class="row" v-if="this.itensFiltrados.length > 0">
          <div class="col-md-4">
            <b-form-group>
              <b-form-select
                :options="optionsPerPage"
                v-model="perPage"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-8">
            <b-pagination
              :total-rows="itensFiltrados.length"
              v-model="currentPage"
              :per-page="perPage"
              align="fill"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MultiSelect from "primevue/multiselect";
import InputText from "primevue/inputtext";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import ApiService from "@/core/services/api.service";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Dropdown from "primevue/dropdown";
import moment from "moment-timezone";

export default {
  name: "NumerosBipados",
  components: { MultiSelect },
  data() {
    return {
      items: [],
      fields: [
        { key: "conta_id", label: "Conta" },
        { key: "cliente_nome", label: "Cliente" },
        { key: "_telefone", label: "Telefone Recente" },
        { key: "actions", label: "Ação" }
      ],
      fieldsTableHistorico: [
        { key: "numero_linha", label: "Telefone" },
        { key: "primeira_ativacao", label: "Data ativação" },
        { key: "ultima_ativacao", label: "Última ativação" },
        { key: "esquenta_chip_ativo", label: "Wellon Booster" },
        { key: "aparelho", label: "Dispositivo" }
      ],
      totalRows: 0,
      optionsPerPage: [
        {
          value: 10,
          text: "Exibir 10 registros por página"
        },
        {
          value: 20,
          text: "Exibir 20 registros por página"
        },
        {
          value: 50,
          text: "Exibir 50 registros por página"
        },
        {
          value: 100,
          text: "Exibir 100 registros por página"
        }
      ],
      perPage: 10,
      currentPage: 1,
      isLoading: false,
      contas: [],
      contasSelecioandas: [],
      telefoneInvalido: false,
      contasInvalidas: false,
      modalHistorico: false,
      itemAberto: {}
    };
  },
  computed: {
    ...mapGetters(["contasParaTroca"]),
    itensFiltrados() {
      let array = [...this.items];
      array = array.filter((i) => {
        if (!this.contasSelecioandas.length) {
          return true;
        }
        return this.contasSelecioandas.includes(i.conta_id);
      });
      array?.forEach((item) => {
        item._telefone = item.historico_numeros[0].numero_linha;
      });
      return array;
    }
  },
  methods: {
    async fetchData(ctx) {
      this.isLoading = true;
      try {
        const response = await ApiService.get("/conta-numeros", null, true);
        this.items = response.data;
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        this.isLoading = false;
      }
    },
    sortChanged(e) {
      this.sortBy = e.sortBy;
      this.orderDirection = e.sortDesc ? "desc" : "asc";
      this.fetchData();
    },
    formatarData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm");
    },
    formatarTelefone(rawPhone) {
      if (!rawPhone) return "-";
      const digits = rawPhone.replace(/\D/g, ""); // Remove não dígitos

      if (digits.length < 12) {
        return digits;
      }

      const country = digits.slice(0, 2); // 55
      const ddd = digits.slice(2, 4); // 71
      const rest = digits.slice(4); // restante do número

      if (rest.length === 8) {
        return `${country} ${ddd} ${rest}`;
      } else if (rest.length === 9) {
        return `${country} ${ddd} ${rest}`;
      } else {
        return digits; // fallback
      }
    },
    abrirModalHistorico(item) {
      this.itemAberto = item;
      this.modalHistorico = true;
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Histórico de números" }]);
    this.contas = this.contasParaTroca.map((conta) => ({
      ...conta,
      label: `${conta.id} - ${conta.login} ${
        conta.nome ? "(" + conta.nome + ")" : ""
      }`
    }));

    this.fetchData();
  }
};
</script>

<style lang="scss" scoped></style>
